// Local Variables
const isInMobileApp = typeof globalThis !== 'undefined' && globalThis.nativeBabbelApp !== undefined;

// Module Exports
export { isInMobileApp };
